/**
 * «Где моя машина» (CONCEPT идея №2). Честная веб-реализация без барометра
 * (браузеры его не отдают — автоопределение этажа только в приложении):
 * позиция машины берётся из QR на колонне парковки или из выбранной зоны,
 * хранится в localStorage (в пределах браузера) И дублируется в URL
 * (`?car=`), чтобы пережить вытеснение кэша — ссылку можно сохранить/переслать.
 */

export interface ParkedCar {
  readonly venueId: string
  /** Юнит парковочной зоны — цель обратного маршрута. */
  readonly targetId: string
  readonly levelId: string
  readonly label: string
  /** ISO-время сохранения (для «поставлено HH:MM»). */
  readonly savedAt: string
}

const KEY_PREFIX = 'car:'

function key(venueId: string): string {
  return `${KEY_PREFIX}${venueId}`
}

function safeGet(k: string): string | null {
  try {
    return localStorage.getItem(k)
  } catch {
    return null
  }
}

function safeSet(k: string, v: string): void {
  try {
    localStorage.setItem(k, v)
  } catch {
    // приватный режим / переполнение — URL-дубль остаётся резервом
  }
}

export function loadCar(venueId: string): ParkedCar | null {
  const raw = safeGet(key(venueId))
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as ParkedCar
    return parsed.venueId === venueId && typeof parsed.targetId === 'string' ? parsed : null
  } catch {
    return null
  }
}

export function saveCar(car: ParkedCar): void {
  safeSet(key(car.venueId), JSON.stringify(car))
}

export function clearCar(venueId: string): void {
  try {
    localStorage.removeItem(key(venueId))
  } catch {
    // ignore
  }
}

/** Обновляет `?car=` в адресной строке без перезагрузки (durability). */
export function reflectCarInUrl(targetId: string | null): void {
  const url = new URL(location.href)
  if (targetId) url.searchParams.set('car', targetId)
  else url.searchParams.delete('car')
  history.replaceState(null, '', url)
}

/** Значение `?car=` из адреса (восстановление после вытеснения кэша). */
export function carParam(search: string): string | null {
  return new URLSearchParams(search).get('car')
}
